import { render, staticRenderFns } from "./BuyerCampaignSettings.vue?vue&type=template&id=488a0b94&scoped=true"
import script from "./BuyerCampaignSettings.vue?vue&type=script&lang=js"
export * from "./BuyerCampaignSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a0b94",
  null
  
)

export default component.exports